var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 7C6.35834 7 5.83334 6.475 5.83334 5.83334C5.83334 5.19167 6.35834 4.66667 7.00001 4.66667C7.64168 4.66667 8.16668 5.19167 8.16668 5.83334C8.16668 6.475 7.64168 7 7.00001 7ZM10.5 5.95C10.5 3.8325 8.95418 2.33334 7.00001 2.33334C5.04584 2.33334 3.50001 3.8325 3.50001 5.95C3.50001 7.315 4.63751 9.12334 7.00001 11.2817C9.36251 9.12334 10.5 7.315 10.5 5.95ZM7.00001 1.16667C9.45001 1.16667 11.6667 3.045 11.6667 5.95C11.6667 7.88667 10.1092 10.1792 7.00001 12.8333C3.89084 10.1792 2.33334 7.88667 2.33334 5.95C2.33334 3.045 4.55001 1.16667 7.00001 1.16667Z",
    fill: "#9A9CAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.a46aeff748e6d282eaf16ac971ed6058.svg";
export { ForwardRef as ReactComponent };